import i18n from '@front/common/i18n'
import Vue from 'vue'

import { router } from '@member-area/core/router'

Vue.use(i18n, {
  router,
  withWarning: false,
})
